import React, { useState } from 'react'
import { addTicket, updateCandidate, uploadRouteFile, fetchCandidateById } from '../lib/api'

function sortRouteByDate(route) {
  const groups = new Map()
  const noTicket = []
  for (const seg of route) {
    if (!seg.ticket_id) { noTicket.push(seg); continue }
    if (!groups.has(seg.ticket_id)) groups.set(seg.ticket_id, [])
    groups.get(seg.ticket_id).push(seg)
  }
  const sorted = [...groups.values()].sort((a, b) => {
    const da = a.reduce((min, s) => s.from_date && s.from_date < min ? s.from_date : min, '9999')
    const db = b.reduce((min, s) => s.from_date && s.from_date < min ? s.from_date : min, '9999')
    return da < db ? -1 : da > db ? 1 : 0
  })
  return [...sorted.flat(), ...noTicket]
}

const TIMEZONES = [
{ label: 'Кабо-Верде (UTC-1)', value: 'Atlantic/Cape_Verde' },
  { label: 'Бразилиа (UTC-3)', value: 'America/Sao_Paulo' },
  { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'Сантьяго (UTC-3/-4)', value: 'America/Santiago' },
  { label: 'Каракас (UTC-4)', value: 'America/Caracas' },
  { label: 'Богота (UTC-5)', value: 'America/Bogota' },
  { label: 'Лима (UTC-5)', value: 'America/Lima' },
  { label: 'Мехико (UTC-6)', value: 'America/Mexico_City' },{ label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },  { label: 'Берлин (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Каир (UTC+2)', value: 'Africa/Cairo' },
  { label: 'Харare (UTC+2)', value: 'Africa/Harare' },
  { label: 'Йоханнесбург (UTC+2)', value: 'Africa/Johannesburg' },
  { label: 'Лагос (UTC+1)', value: 'Africa/Lagos' },
  { label: 'Найроби (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Аддис-Абеба (UTC+3)', value: 'Africa/Addis_Ababa' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
  { label: 'Дубай (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Дели (UTC+5:30)', value: 'Asia/Kolkata' },
  { label: 'Астана / Омск (UTC+6)', value: 'Asia/Almaty' },
  { label: 'Бангкок (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'Манила (UTC+8)', value: 'Asia/Manila' },
  { label: 'Гонконг (UTC+8)', value: 'Asia/Hong_Kong' },
  { label: 'Пекин (UTC+8)', value: 'Asia/Shanghai' },
  { label: 'Токио (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
]

function emptySegment(tz) {
  return { from: '', from_tz: tz || 'Africa/Harare', to: '', to_tz: tz || 'Africa/Harare', departure_date: '', departure_time: '', arrival_date: '', arrival_time: '' }
}

export default function TicketModal({ candidates, locations, currentUserId, currentUserName, onClose, onSaved }) {
  const [candidateId, setCandidateId] = useState('')
  const [type, setType] = useState('авиа')
  const [segments, setSegments] = useState([emptySegment()])
  const [ticketNumber, setTicketNumber] = useState('')
  const [price, setPrice] = useState('')
  const [aggregator, setAggregator] = useState('')
  const [airline, setAirline] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  const [refundStatus, setRefundStatus] = useState('')
  const [search, setSearch] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)
  const [file, setFile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [sameAsBuyer, setSameAsBuyer] = useState(true)
  const [purchasedBy, setPurchasedBy] = useState('')

  const filteredCandidates = candidates.filter(c => {
    if (c.archived) return false
    if (!search) return true
    const q = search.toLowerCase()
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q)
  })
  const selectedCandidate = candidates.find(c => c.id === candidateId)

  function setSeg(idx, field, value) {
    setSegments(segs => segs.map((s, i) => i === idx ? { ...s, [field]: value } : s))
  }

  function addSegment() {
    setSegments(segs => {
      const last = segs[segs.length - 1]
      return [...segs, { ...emptySegment(last.to_tz), from: last.to, from_tz: last.to_tz }]
    })
  }

  function removeSegment(idx) {
    if (segments.length === 1) return
    setSegments(segs => segs.filter((_, i) => i !== idx))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!candidateId) { alert('Выберите кандидата'); return }
    const firstSeg = segments[0]
    if (!firstSeg.from || !firstSeg.to || !firstSeg.departure_date) {
      alert('Заполните первый сегмент: откуда, куда, дату вылета')
      return
    }
    setSaving(true)
    try {
      let fileData = null
      if (file) fileData = await uploadRouteFile(file, 'ticket_' + candidateId + '_' + Date.now(), 'ticket')

      const buyer = sameAsBuyer ? currentUserName : purchasedBy

const savedTicket = await addTicket({
        candidate_id: candidateId,
        type,
        from_city: firstSeg.from,
        from_tz: firstSeg.from_tz,
        to_city: segments[segments.length - 1].to,
        to_tz: segments[segments.length - 1].to_tz,
        departure_date: firstSeg.departure_date,
        departure_time: firstSeg.departure_time || null,
        arrival_date: segments[segments.length - 1].arrival_date || null,
        arrival_time: segments[segments.length - 1].arrival_time || null,
        ticket_number: ticketNumber,
        price: price || 0,
        purchased_by: buyer,
        file: fileData,
        payer_card_name: buyer,
        aggregator: aggregator,
        airline: airline,
        payment_method: paymentMethod,
        refund_status: refundStatus,
      })
      const fresh = await fetchCandidateById(selectedCandidate.id)
      const newRoutePoints = segments.filter(s => s.from && s.to).map((s, i) => ({
        from: s.from, from_tz: s.from_tz, from_date: s.departure_date, from_time: s.departure_time,
        to: s.to, to_tz: s.to_tz, to_date: s.arrival_date || s.departure_date, to_time: s.arrival_time,
        note: (type === 'авиа' ? 'Авиабилет' : 'Автобусный билет') + (segments.length > 1 ? ' (сегмент ' + (i + 1) + ' из ' + segments.length + ')' : ''),
        files: i === 0 && fileData ? [fileData] : [],
        ticket_id: savedTicket.id
      }))
      const updatedRoute = sortRouteByDate([...(Array.isArray(fresh.route) ? fresh.route : []), ...newRoutePoints])

      const newExpense = {
        category: type === 'авиа' ? 'Авиабилеты' : 'Автобус',
        amount: price || 0,
        comment: 'Билет ' + firstSeg.from + ' → ' + segments[segments.length - 1].to + (segments.length > 1 ? ' (со стыковками)' : '') + (ticketNumber ? ' (' + ticketNumber + ')' : ''),
        operator_id: currentUserId,
        location_id: fresh.location_id,
        location_name: locations.find(l => l.id === fresh.location_id)?.name || ''
      }
      const updatedExpenses = [...(fresh.expenses || []), newExpense]

      await updateCandidate(fresh.id, { route: updatedRoute, expenses: updatedExpenses })

      await onSaved()
    } catch (err) { alert('Ошибка: ' + err.message) }
    setSaving(false)
  }

  const inputStyle = { width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white' }

  return (
    <div className="modal-backdrop">
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>+ Новая поездка</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <label>Кандидат *</label>
          <div style={{ position: 'relative', marginBottom: 12 }}>
            <input value={selectedCandidate ? selectedCandidate.name : search} onChange={e => { setSearch(e.target.value); setCandidateId(''); setShowDropdown(true) }} onFocus={() => setShowDropdown(true)} placeholder="Поиск по имени или паспорту..." style={inputStyle} />
            {showDropdown && filteredCandidates.length > 0 && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e0e0dc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: 200, overflowY: 'auto', marginTop: 2 }}>
                {filteredCandidates.map(c => (
                  <div key={c.id} onMouseDown={() => { setCandidateId(c.id); setSearch(''); setShowDropdown(false) }} style={{ padding: '8px 12px', fontSize: 13, cursor: 'pointer', borderBottom: '0.5px solid #f5f5f3' }} onMouseOver={e => e.target.style.background = '#f5f5f3'} onMouseOut={e => e.target.style.background = 'transparent'}>
                    {c.name} <span style={{ color: '#888', fontSize: 11 }}>{c.passport}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <label>Тип билета
            <select value={type} onChange={e => setType(e.target.value)}>
              <option value="авиа">✈ Авиабилет</option>
              <option value="автобус">🚌 Автобус</option>
            </select>
          </label>

          <div className="form-section-label" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Маршрут билета</span>
            <button type="button" onClick={addSegment} style={{ fontSize: 12, padding: '3px 10px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'transparent', cursor: 'pointer', color: '#555' }}>+ Добавить стыковку</button>
          </div>

          {segments.map((seg, idx) => (
            <div key={idx} style={{ background: '#fafaf8', border: '1px solid #efefec', borderRadius: 10, padding: '12px 14px', marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: '#888' }}>{segments.length > 1 ? 'Сегмент ' + (idx + 1) : 'Маршрут'}</span>
                {segments.length > 1 && <button type="button" onClick={() => removeSegment(idx)} style={{ fontSize: 11, color: '#E24B4A', background: 'transparent', border: 'none', cursor: 'pointer' }}>Удалить</button>}
              </div>
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Откуда</label>
              <input value={seg.from} onChange={e => setSeg(idx, 'from', e.target.value)} placeholder="Город отправления" style={{ ...inputStyle, marginBottom: 8 }} />
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Часовой пояс отправления</label>
              <select value={seg.from_tz} onChange={e => setSeg(idx, 'from_tz', e.target.value)} style={{ ...inputStyle, marginBottom: 8 }}>
                {TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
              </select>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Дата вылета/выезда</label>
                  <input type="date" value={seg.departure_date} onChange={e => setSeg(idx, 'departure_date', e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Время (местное)</label>
                  <input type="time" value={seg.departure_time} onChange={e => setSeg(idx, 'departure_time', e.target.value)} style={inputStyle} />
                </div>
              </div>
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Куда {segments.length > 1 && idx < segments.length - 1 ? '(стыковка)' : ''}</label>
              <input value={seg.to} onChange={e => setSeg(idx, 'to', e.target.value)} placeholder="Город прибытия" style={{ ...inputStyle, marginBottom: 8 }} />
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Часовой пояс прибытия</label>
              <select value={seg.to_tz} onChange={e => setSeg(idx, 'to_tz', e.target.value)} style={{ ...inputStyle, marginBottom: 8 }}>
                {TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
              </select>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Дата прибытия</label>
                  <input type="date" value={seg.arrival_date} onChange={e => setSeg(idx, 'arrival_date', e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Время (местное)</label>
                  <input type="time" value={seg.arrival_time} onChange={e => setSeg(idx, 'arrival_time', e.target.value)} style={inputStyle} />
                </div>
              </div>
            </div>
          ))}

          <label>Номер билета / бронирования
            <input value={ticketNumber} onChange={e => setTicketNumber(e.target.value)} placeholder="Номер" />
          </label>
          <label>Авиакомпания
            <input value={airline} onChange={e => setAirline(e.target.value)} placeholder="Emirates, Ethiopian..." />
          </label>
          <label>Агрегатор
            <input value={aggregator} onChange={e => setAggregator(e.target.value)} placeholder="Авиасейлс, напрямую..." />
          </label>
          <label>Платёжное средство
            <input value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} placeholder="Карта, ППМ премиальная..." />
          </label>
          <label>Стоимость (₽)
            <input type="number" value={price} onChange={e => setPrice(e.target.value)} placeholder="0" />
          </label>
          <label>Статус билета
            <select value={refundStatus} onChange={e => setRefundStatus(e.target.value)}>
              <option value="">— в процессе —</option>
              <option value="Успех">Успех (долетел)</option>
              <option value="Возврат">Возврат (подан на возврат)</option>
            </select>
          </label>

          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 8 }}>
            <input type="checkbox" checked={sameAsBuyer} onChange={e => setSameAsBuyer(e.target.checked)} style={{ width: 'auto' }} />
            Билет покупал я ({currentUserName})
          </label>
          {!sameAsBuyer && (
            <label>Кто купил билет
              <input value={purchasedBy} onChange={e => setPurchasedBy(e.target.value)} placeholder="Имя того, кто купил" />
            </label>
          )}

          <label style={{ display: 'inline-block', fontSize: 12, padding: '6px 12px', border: '1px dashed #d0d0cc', borderRadius: 7, cursor: 'pointer', color: '#888', marginBottom: 8 }}>
            📎 {file ? file.name : 'Прикрепить файл билета'}
            <input type="file" accept="image/*,.pdf" onChange={e => setFile(e.target.files[0])} style={{ display: 'none' }} />
          </label>

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Сохранение...' : 'Добавить'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}